export const CONSTANTS = {
	BASE_URL: process.env.VUE_APP_API_BASE_URL_EKS
}
export const COUNTRYCODE = {
	YE: 'ye',
	AO: 'ao',
	AU: 'au',
	NZ: 'nz'
}
